import { BoardOption } from '@/hooks/board/useBoardFormOptions';
import { BooleanOption } from '@/hooks/board/useBoardForm';

export const DisplaySectionOptions: BoardOption[] = [
  {
    value: 'bannerSection',
    label: '메인 배너',
  },
  {
    value: 'rightFixSection',
    label: '우측 상단 배너',
  },
  {
    value: 'rightSection',
    label: '새 소식을 전해드립니다!',
  },
  {
    value: 'importantSection',
    label: '결혼 축하',
  },
  {
    value: 'interviewSection',
    label: '입사 축하',
  },
  {
    value: 'none',
    label: '미노출하기',
  },
];

export const CommentPositionOptions = [
  {
    id: 'footerSection',
    selected_image: '/icons/comment_layout/comment-footer-active.svg',
    image: '/icons/comment_layout/comment-footer.svg',
    label: '게시글 아래',
  },
  {
    id: 'rightSection',
    selected_image: '/icons/comment_layout/comment-right-active.svg',
    image: '/icons/comment_layout/comment-right.svg',
    label: '게시글 오른쪽',
  },
];

export const UploadTimeOptions: BoardOption[] = [
  { value: BooleanOption.FALSE, label: '바로 올리기' },
  { value: BooleanOption.TRUE, label: '예약하기' },
];

export const ImportantOptions: BoardOption[] = [
  { value: BooleanOption.TRUE, label: '설정하기' },
  { value: BooleanOption.FALSE, label: '설정 안하기' },
];
